import { Plus, Minus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCart } from '@/context/CartContext';

export function CartItem({ item }) {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div 
      className="flex items-center gap-3 p-3 bg-white rounded-xl border border-border"
      data-testid={`cart-item-${item.product_id}`}
    >
      {/* Image */}
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0 bg-muted/30">
        <img
          src={item.image_url}
          alt={item.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Details */}
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-sm md:text-base line-clamp-1">{item.name}</h3>
        <p className="text-xs text-muted-foreground">{item.unit}</p>
        <p className="font-bold text-primary mt-1">₹{(item.price * item.quantity).toFixed(0)}</p>
      </div>

      {/* Quantity Controls */}
      <div className="flex items-center gap-2">
        <div className="flex items-center bg-muted rounded-full">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => updateQuantity(item.product_id, item.quantity - 1)}
            className="h-8 w-8 rounded-full"
            data-testid={`cart-decrease-${item.product_id}`}
          >
            <Minus className="w-4 h-4" />
          </Button>
          <span className="w-8 text-center font-bold text-sm">{item.quantity}</span>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => updateQuantity(item.product_id, item.quantity + 1)}
            className="h-8 w-8 rounded-full"
            data-testid={`cart-increase-${item.product_id}`}
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={() => removeFromCart(item.product_id)}
          className="h-8 w-8 text-destructive hover:text-destructive/80"
          data-testid={`cart-remove-${item.product_id}`}
        >
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
